module.exports = __webpack_public_path__ + "img/paved_asphalted.6aa75cf0.png";